import { z } from "zod/v4";
import { CameraSubject, CollectionResponse, defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { isoDatetimeToDateString } from "@visioni/a3s-codecs";
import { FEATURE_NAME } from "../constants";
import { SignedSnapshot } from "./snapshots";

export const ListSnapshotHistoryQueryParams = z.object({
  startTime: isoDatetimeToDateString,
  endTime: isoDatetimeToDateString,
});

export type ListSnapshotHistoryQueryParams = z.output<typeof ListSnapshotHistoryQueryParams>;

export const SnapshotHistoryItem = z.object({
  subject: CameraSubject,
  timestamp: z.string(),
  snapshot: SignedSnapshot,
});

export type SnapshotHistoryItem = z.output<typeof SnapshotHistoryItem>;

export const ListSnapshotHistoryResponse = CollectionResponse(SnapshotHistoryItem);

export type ListSnapshotHistoryResponse = z.output<typeof ListSnapshotHistoryResponse>;

// ==================== Resources & Endpoints ====================

export const snapshotHistoryResource = defineResource({
  feature: FEATURE_NAME,
  resource: "snapshots/history",
});

export const listSnapshotHistoryEndpoint = defineEndpoint(snapshotHistoryResource, {
  responseSchema: ListSnapshotHistoryResponse,
  querySchema: ListSnapshotHistoryQueryParams,
});
